'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectShouldOnlyShowMap = exports.selectShouldShowMap = exports.getUserLocationForSearch = exports.isRootSearchPath = exports.makeUrlFromLayout = exports.selectResultTypeFromSearchResults = exports.selectFiltersFromSearchResults = exports.selectLocationAutocompleteFromSearchResults = exports.selectResultsFromLayout = exports.selectCalculatedRadiusKmInLayout = exports.selectLocationAutocompleteTimezoneInLayout = exports.selectLocationAutocompleteValueInLayout = exports.selectLocationAutocompleteEntryInLayout = exports.selectKeywordAutocompleteValueInLayout = exports.selectKeywordAutocompleteEntryInLayout = exports.selectErrorInLayout = exports.selectResolvedFilterDataInLayout = exports.selectFiltersForHashInLayout = exports.selectMetadataInLayout = exports.selectSearchIdInLayout = exports.selectCursorInLayout = exports.selectMapItemsInLayout = exports.selectRadiusUsedInLayout = exports.selectVenuesInLayout = exports.selectSchedulesInLayout = exports.selectTotalHitsInLayout = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _bound = require('redux/saga/entities/bound');

var _device = require('redux/modules/device');

var _locale = require('redux/modules/locale');

var _deep = require('helpers/deep');

var _Search = require('./Search.route');

var _SearchMap = require('./Map/SearchMap.constants');

var _SearchBox = require('./SearchBox/SearchBox.reducer');

var _Search2 = require('./Search.reducer');

var _Search3 = require('./Search.constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var selectFieldInDataOfLayout = function selectFieldInDataOfLayout(field, defaultValue, layout) {
  return (0, _deep.deepExtract)('data.' + field, layout && layout[(0, _keys2.default)(layout)[0]], defaultValue);
};

var selectTotalHitsInLayout = exports.selectTotalHitsInLayout = selectFieldInDataOfLayout.bind(null, 'total_hits', null);
var selectSchedulesInLayout = exports.selectSchedulesInLayout = selectFieldInDataOfLayout.bind(null, 'schedules', null);
var selectVenuesInLayout = exports.selectVenuesInLayout = selectFieldInDataOfLayout.bind(null, 'venue_tab_items', null);
var selectRadiusUsedInLayout = exports.selectRadiusUsedInLayout = selectFieldInDataOfLayout.bind(null, 'radius_used', _SearchMap.DEFAULT_KILOMETERS);
var selectMapItemsInLayout = exports.selectMapItemsInLayout = selectFieldInDataOfLayout.bind(null, 'map_items', []);
var selectCursorInLayout = exports.selectCursorInLayout = selectFieldInDataOfLayout.bind(null, 'cursor', '');
var selectSearchIdInLayout = exports.selectSearchIdInLayout = selectFieldInDataOfLayout.bind(null, 'search_id', null);
var selectMetadataInLayout = exports.selectMetadataInLayout = selectFieldInDataOfLayout.bind(null, 'filter_metadata', {});
var selectFiltersForHashInLayout = exports.selectFiltersForHashInLayout = selectFieldInDataOfLayout.bind(null, 'filters_for_hash', {});
var selectResolvedFilterDataInLayout = exports.selectResolvedFilterDataInLayout = selectFieldInDataOfLayout.bind(null, 'resolved_filter_data', {});
var selectErrorInLayout = exports.selectErrorInLayout = selectFieldInDataOfLayout.bind(null, 'module_error', null);
var selectKeywordAutocompleteEntryInLayout = exports.selectKeywordAutocompleteEntryInLayout = function selectKeywordAutocompleteEntryInLayout(layout) {
  return (0, _deep.deepExtract)('keyword_autocomplete_entry', selectResolvedFilterDataInLayout(layout), {});
};
var selectKeywordAutocompleteValueInLayout = exports.selectKeywordAutocompleteValueInLayout = function selectKeywordAutocompleteValueInLayout(layout) {
  return selectKeywordAutocompleteEntryInLayout(layout).name || '';
};
var selectLocationAutocompleteEntryInLayout = exports.selectLocationAutocompleteEntryInLayout = function selectLocationAutocompleteEntryInLayout(layout) {
  return (0, _deep.deepExtract)('location_autocomplete_entry', selectResolvedFilterDataInLayout(layout), {});
};
var selectLocationAutocompleteValueInLayout = exports.selectLocationAutocompleteValueInLayout = function selectLocationAutocompleteValueInLayout(layout) {
  return selectLocationAutocompleteEntryInLayout(layout).name || '';
};
var selectLocationAutocompleteTimezoneInLayout = exports.selectLocationAutocompleteTimezoneInLayout = function selectLocationAutocompleteTimezoneInLayout(layout) {
  return selectLocationAutocompleteEntryInLayout(layout).timezone || '';
};
var selectCalculatedRadiusKmInLayout = exports.selectCalculatedRadiusKmInLayout = function selectCalculatedRadiusKmInLayout(layout) {
  return (0, _deep.deepExtract)('location_autocomplete_entry.calculated_radius_km', selectResolvedFilterDataInLayout(layout), '');
};

var selectResultsFromLayout = exports.selectResultsFromLayout = function selectResultsFromLayout(state) {
  var pageNumber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  return _bound.searchLayoutByName.data(state, _Search3.RESULTS_LAYOUT + '_' + pageNumber);
};

var selectLocationAutocompleteFromSearchResults = exports.selectLocationAutocompleteFromSearchResults = function selectLocationAutocompleteFromSearchResults(state) {
  return (0, _deep.deepExtract)('location_autocomplete_entry', selectResolvedFilterDataInLayout(selectResultsFromLayout(state)), {});
};
var selectFiltersFromSearchResults = exports.selectFiltersFromSearchResults = function selectFiltersFromSearchResults(state) {
  return selectFiltersForHashInLayout(selectResultsFromLayout(state));
};
var selectResultTypeFromSearchResults = exports.selectResultTypeFromSearchResults = function selectResultTypeFromSearchResults(state) {
  return (0, _deep.deepExtract)('result_type', selectFiltersFromSearchResults(state));
};

var makeUrlFromLayout = exports.makeUrlFromLayout = function makeUrlFromLayout(layout) {
  var metadata = selectMetadataInLayout(layout);
  if (metadata.descriptor && metadata.hash) {
    return _Search.PATH + '/' + metadata.location_descriptor + '/' + metadata.descriptor + '/' + metadata.hash;
  }
};

var isRootSearchPath = exports.isRootSearchPath = function isRootSearchPath(pathname) {
  return pathname === _Search.PATH;
};

// The user's location for search is async-initialized in app.saga.js
// which calls into search.saga.js' (initializeUserLocationForSearch)
var getUserLocationForSearch = exports.getUserLocationForSearch = function getUserLocationForSearch(state) {
  return (0, _SearchBox.selectActiveLocation)(state) || (0, _locale.selectUserLocation)(state) || _Search3.DEFAULT_GEOLOCATION;
};

var selectShouldShowMap = exports.selectShouldShowMap = function selectShouldShowMap(state) {
  return (0, _device.selectMediaState)(state).lg || (0, _Search2.selectMapView)(state);
};

// Mobile, map-view
var selectShouldOnlyShowMap = exports.selectShouldOnlyShowMap = function selectShouldOnlyShowMap(state) {
  return (0, _device.selectIsMobile)(state) && (0, _Search2.selectMapView)(state);
};